<template>
    <img src="/images/promo/hero-section/spiral-calendar.png"
     alt="Spiral calendar" />
</template>

<script>
export default {};
</script>
